import { useMemo } from 'react';
import useSWR from 'swr';
import { HandlersSimDetailsResponse } from 'types/__generated__/SimInventoryApi';
import getFetcher from 'api/utils/getFetcher';
import { ApiBaseError } from '../utils/shared';

export interface SimDetailsResultError extends ApiBaseError {}

const useSimDetails = (hologramSimId?: HologramSimId) => {
  const url = hologramSimId
    ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${hologramSimId}`
    : null;

  const { data, error, isLoading, mutate, isValidating } = useSWR<
    HandlersSimDetailsResponse,
    SimDetailsResultError
  >(url, getFetcher);

  const simDetails = useMemo(() => {
    const newSimDetails = data?.simDetails ?? {};

    // TODO: Use field returned from API when it's available
    if (newSimDetails?.fallbackInstalled) {
      newSimDetails.fallbackEnabled = newSimDetails.fallbackInstalled;
    }
    return newSimDetails;
  }, [data]);

  return {
    simDetails,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useSimDetails;
